/*
    Helper -> GeneriInterstitial

    1. Build Commercial Interstitials
        - contentInterstitialsFirstImage
        - contentInterstitialsSecondImage
        - contentInterstitialsThirdImage
        - buildTemplateCommercialA
        - buildTemplateCommercialB
        - buildTemplateCommercialC
        - buildTemplateCommercialD
        - buildTemplateCommercialE
        - buildTemplateCommercialF
        - buildTemplateCommercialG

    2. Token functions (remember that the user close or not the interstitial)
        - updateTokenUserInterstitial
        - hasTokenInterstitial
*/

// @vendors
const React = require('react');
const Storage = require('utilities/storage');
const moment = require('moment');

// @components
const { InterstitialA } = require('okInterstitials/InterstitialA');
const { InterstitialB } = require('okInterstitials/InterstitialB');
const { InterstitialC } = require('okInterstitials/InterstitialC');
const { InterstitialD } = require('okInterstitials/InterstitialD');
const { InterstitialE } = require('okInterstitials/InterstitialE');
const { InterstitialF } = require('okInterstitials/InterstitialF');
const { InterstitialG } = require('okInterstitials/InterstitialG');
const { InterstitialAdvanced } = require('okInterstitials/InterstitialAdvanced')

// @helpers
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getPersonTypeAndCodeHashed } = require('utilities/hash');

// @constants
const { CODE_ADDRESS_EXT } = require('constants/index');

// Build Commercial Interstitials
function contentInterstitialsFirstImage(content, isDesktop) {
    const contentInterstitial = {
        "firstTitle": content.getIn(['content', 'layoutFilteredContent', 'firstInterstitial', 'title']),
        "firstDescription": content.getIn(['content', 'layoutFilteredContent','firstInterstitial', 'description']),
        "legalDescription": content.getIn(['content', 'layoutFilteredContent','legalDescription']),
        "extraLegalDescription": content.getIn(['content', 'layoutFilteredContent','extraLegalDescription']),
        "firstCtaTextAlignment": content.getIn(['content', 'layoutFilteredContent','firstInterstitial', 'cta', 'ctaTextAlignment']),
        "firstCtaPrimaryBgColor": content.getIn(['content', 'layoutFilteredContent','firstInterstitial', 'cta', 'ctaPrimaryBgColor']),
        "firstCtaPrimaryNewTab": content.getIn(['content', 'layoutFilteredContent','firstInterstitial', 'cta', 'ctaPrimaryNewTab']),
        "firstCtaPrimaryText": content.getIn(['content', 'layoutFilteredContent','firstInterstitial', 'cta', 'ctaPrimaryText']),
        "firstCtaPrimaryURL": content.getIn(['content', 'layoutFilteredContent','firstInterstitial', 'cta', 'ctaPrimaryUrl']),
        "firstCtaPrimaryType": content.getIn(['content', 'layoutFilteredContent','firstInterstitial', 'cta', 'ctaPrimaryType']),
        "firstCtaPrimaryRel": content.getIn(['content', 'layoutFilteredContent','firstInterstitial', 'cta', 'ctaPrimaryRel']),
        "firstCtaPrimaryUnderlined": content.getIn(['content', 'layoutFilteredContent','firstInterstitial', 'cta', 'ctaPrimaryUnderlined']),
        "firstCtaSecondaryBgColor": content.getIn(['content', 'layoutFilteredContent','firstInterstitial', 'cta', 'ctaSecondaryBgColor']),
        "firstCtaSecondaryText": content.getIn(['content', 'layoutFilteredContent','firstInterstitial', 'cta', 'ctaSecondaryText']),
        "firstCtaSecondaryURL": content.getIn(['content', 'layoutFilteredContent','firstInterstitial', 'cta', 'ctaSecondaryUrl']),
        "firstCtaSecondaryNewTab": content.getIn(['content', 'layoutFilteredContent','firstInterstitial', 'cta', 'ctaSecondaryNewTab']),
        "firstCtaSecondaryType": content.getIn(['content', 'layoutFilteredContent','firstInterstitial', 'cta', 'ctaSecondaryType']),
        "firstCtaSecondaryUnderlined": content.getIn(['content', 'layoutFilteredContent','firstInterstitial', 'cta', 'ctaSecondaryUnderlined']),
        "firstImagePath": content.getIn(['content', 'layoutFilteredContent', 'firstInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'imagePath']),
        "firstImageUrl": content.getIn(['content', 'layoutFilteredContent', 'firstInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'imageUrl']),
        "firstImageTitle": content.getIn(['content', 'layoutFilteredContent', 'firstInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'imageTitle']),
        "firstImageAlt": content.getIn(['content', 'layoutFilteredContent', 'firstInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'imageAlt']),
        "firstImageNewTab": content.getIn(['content', 'layoutFilteredContent', 'firstInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'imageNewTab']),
        "firstVideoTitle": content.getIn(['content', 'layoutFilteredContent', 'firstInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'videoTitle']),
        "firstVideoPath": content.getIn(['content', 'layoutFilteredContent', 'firstInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'videoPath']),
        "firstVideoAutoplay": content.getIn(['layoutFilteredContent', 'firstInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'videoAutoplay']),
        "firstVideoAlt": content.getIn(['content', 'layoutFilteredContent', 'firstInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'videoAlt']),
        "firstVideoBg": content.getIn(['content', 'layoutFilteredContent', 'firstInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'videoBg']),
        "contentSectionBgColor": content.getIn(['content', 'layoutFilteredContent', 'firstInterstitial', 'contentSectionBgColor']),
        "flexibleText": content.getIn(['content', 'layoutFilteredContent', 'firstInterstitial', 'commercialBox', 'flexibleText']),
        "fieldFlexible": content.getIn(['content', 'layoutFilteredContent', 'firstInterstitial', 'commercialBox', 'flexible']),
        "boxAlignment": content.getIn(['content', 'layoutFilteredContent', 'firstInterstitial', 'commercialBox', 'boxAlignment']),
        "contrast": content.getIn(['content', 'layoutFilteredContent', 'firstInterstitial', 'commercialBox', 'contrast']),
    }
    return contentInterstitial;
}

function getPersonalInformation(fieldLabels, profileFields, immProfileShippingAddress) {
    let valueEmpty = false;
    const fieldsPlaceholder = Object.keys(fieldLabels.toJS()).map((key) => {
        let data = {
            label: fieldLabels.get(key)
        };
        switch(key) {
            case 'email':
                data.value = PersonalDataHelper.getEmail(profileFields);
                break;
            case 'phone':
                data.value = PersonalDataHelper.getPhoneNumber(profileFields);
                break;
            case 'addressHome':
                data.value = PersonalDataHelper.getFormattedAddress(profileFields);
                break;
            case 'correspondenceAddress':
                if (immProfileShippingAddress.get('fetchSuccess') && immProfileShippingAddress.get('hasShippingAddress')) {
                    if (immProfileShippingAddress.get('codFormatoDomicilio') === CODE_ADDRESS_EXT) {
                        data.value = PersonalDataHelper.getFormattedShippingAddressExt(immProfileShippingAddress.get('shippingAddressExt').toJS());
                    } else {
                        data.value = PersonalDataHelper.getFormattedShippingAddress(immProfileShippingAddress.get('shippingAddress').toJS());
                    }
                } else {
                    data.value = '';
                }
                break;
        }
        if (['email', 'phone', 'addressHome', 'correspondenceAddress'].includes(key) && !data.value){
            valueEmpty = true;
        }
        return data;
    });
    return {
        fieldsPlaceholder,
        valueEmpty
    }
}

function getUpdatedTitle(immContent, immProfile) {
    const title = immContent.getIn(['content', 'advancedInterstitialContent', 'title']);
    let userName = immProfile && (immProfile.get('alias') || immProfile.get('nombreCliente'));
    userName = title.replace('${name}', userName);
    return userName;
}

function getPrimaryCTADetails(immContent, isAnyPersonalInfoEmpty) {
    const immCtaDetails =  immContent.getIn(['content', 'advancedInterstitialContent', 'cta']);
    const ctaPrimaryUrl = immCtaDetails.get('ctaPrimaryUrl');
    if (isAnyPersonalInfoEmpty && ctaPrimaryUrl.includes('myprofile/edit?updated=true')) {
        return {};
    } else {
        return {
            firstCtaPrimaryBgColor: immCtaDetails.get('ctaPrimaryBgColor'),
            firstCtaPrimaryNewTab: 0,
            firstCtaPrimaryText: immCtaDetails.get('ctaPrimaryText'),
            firstCtaPrimaryType: immCtaDetails.get('ctaPrimaryType'),
            firstCtaPrimaryURL: ctaPrimaryUrl,
            firstCtaPrimaryUnderlined: immCtaDetails.get('ctaPrimaryUnderlined'),
            firstCtaTextAlignment: immCtaDetails.get('ctaTextAlignment'),
        }
    }
}

function getSecondaryCTADetails(immContent, isAnyPersonalInfoEmpty) {
    const immCtaDetails =  immContent.getIn(['content', 'advancedInterstitialContent', 'cta']);
    const ctaSecondaryUrl = immCtaDetails.get('ctaSecondaryUrl', '');
    if (isAnyPersonalInfoEmpty && ctaSecondaryUrl.includes('myprofile/edit?updated=true')) {
        return {};
    } else {
        return {
            firstCtaSecondaryBgColor: immCtaDetails.get('ctaSecondaryBgColor'),
            firstCtaSecondaryNewTab: 0,
            firstCtaSecondaryText: immCtaDetails.get('ctaSecondaryText'),
            firstCtaSecondaryType: immCtaDetails.get('ctaSecondaryType'),
            firstCtaSecondaryURL: ctaSecondaryUrl,
            firstCtaSecondaryUnderlined: immCtaDetails.get('ctaSecondaryUnderlined'),
        }
    }
}

//Build Advance Interstitial Contents
function advanceInterstitialContents(immContent, immProfile, immProfileShippingAddress, isDesktop) {
    const immAdvanceInterstitialContents = immContent.getIn(['content', 'advancedInterstitialContent']);
    const immMultimediaDetails = immAdvanceInterstitialContents.getIn([`${isDesktop ? 'multimedia' : 'tabletMultimedia'}`]);
    const fieldLabels = immAdvanceInterstitialContents.get('fieldLabels');
    const newTitle = getUpdatedTitle(immContent, immProfile);
    const personalFieldInformation = getPersonalInformation(fieldLabels, immProfile, immProfileShippingAddress);
    const primaryCTADetails = getPrimaryCTADetails(immContent, personalFieldInformation.valueEmpty);
    const secondaryCTADetails = getSecondaryCTADetails(immContent, personalFieldInformation.valueEmpty);
    const contentInterstitial = {
        ...primaryCTADetails,
        ...secondaryCTADetails,
        contentSectionBgColor: immAdvanceInterstitialContents.get('contentSectionBgColor'),
        fieldsPlaceHolder: personalFieldInformation.fieldsPlaceholder,
        fieldsPlaceHolderColor: immAdvanceInterstitialContents.get('fieldlabelColor'),
        firstDescription: immAdvanceInterstitialContents.get('description'),
        firstImageAlt: immMultimediaDetails.get('imageAlt'),
        firstImageNewTab: immMultimediaDetails.get('imageNewTab'),
        firstImagePath: immMultimediaDetails.get('imagePath'),
        firstImageTitle: immMultimediaDetails.get('imageTitle'),
        firstImageUrl: immMultimediaDetails.get('imageUrl'),
        firstTitle: newTitle,
        firstVideoAlt: immMultimediaDetails.get('videoAlt'),
        firstVideoAutoplay: immMultimediaDetails.get('videoAutoplay'),
        firstVideoBg: immMultimediaDetails.get('videoBg'),
        firstVideoPath: immMultimediaDetails.get('videoPath'),
        firstVideoTitle: immMultimediaDetails.get('videoTitle'),
        legalDescription:  immAdvanceInterstitialContents.get('legalDescription'),
        missingFieldBgColor: immAdvanceInterstitialContents.getIn(['missingFieldLabel', 'bgColor']),
        missingFieldLabel: immAdvanceInterstitialContents.getIn(['missingFieldLabel', 'body']),
    }
    return contentInterstitial;
}

function contentInterstitialsSecondImage(content, isDesktop) {
    const contentInterstitial = {
        "headerTitle": content.getIn(['content', 'layoutFilteredContent', 'headerTitle']),
        "secondTitle": content.getIn(['content', 'layoutFilteredContent', 'secondInterstitial', 'title']),
        "secondDescription": content.getIn(['content', 'layoutFilteredContent', 'secondInterstitial', 'description']),
        "secondCtaPrimaryBgColor": content.getIn(['content', 'layoutFilteredContent','secondInterstitial', 'cta', 'ctaPrimaryBgColor']),
        "secondCtaPrimaryNewTab": content.getIn(['content', 'layoutFilteredContent','secondInterstitial', 'cta', 'ctaPrimaryNewTab']),
        "secondCtaPrimaryText": content.getIn(['content', 'layoutFilteredContent','secondInterstitial', 'cta', 'ctaPrimaryText']),
        "secondCtaPrimaryURL": content.getIn(['content', 'layoutFilteredContent','secondInterstitial', 'cta', 'ctaPrimaryUrl']),
        "secondCtaPrimaryType": content.getIn(['content', 'layoutFilteredContent','secondInterstitial', 'cta', 'ctaPrimaryType']),
        "secondCtaPrimaryUnderlined": content.getIn(['content', 'layoutFilteredContent','secondInterstitial', 'cta', 'ctaPrimaryUnderlined']),
        "secondCtaTextAlignment": content.getIn(['content', 'layoutFilteredContent','secondInterstitial', 'cta', 'ctaTextAlignment']),
        "secondCtaSecondaryBgColor": content.getIn(['content', 'layoutFilteredContent','secondInterstitial', 'cta', 'ctaSecondaryBgColor']),
        "secondCtaSecondaryText": content.getIn(['content', 'layoutFilteredContent','secondInterstitial', 'cta', 'ctaSecondaryText']),
        "secondCtaSecondaryURL":content.getIn(['content', 'layoutFilteredContent','secondInterstitial', 'cta', 'ctaSecondaryUrl']),
        "secondCtaSecondaryNewTab": content.getIn(['content', 'layoutFilteredContent','secondInterstitial', 'cta', 'ctaSecondaryNewTab']),
        "secondCtaSecondaryType": content.getIn(['content', 'layoutFilteredContent','secondInterstitial', 'cta', 'ctaSecondaryType']),
        "secondCtaSecondaryUnderlined": content.getIn(['content', 'layoutFilteredContent','secondInterstitial', 'cta', 'ctaSecondaryUnderlined']),
        "secondImageAlt": content.getIn(['content', 'layoutFilteredContent', 'secondInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'imageAlt']),
        "secondImagePath": content.getIn(['content', 'layoutFilteredContent', 'secondInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'imagePath']),
        "secondImageTitle": content.getIn(['content', 'layoutFilteredContent', 'secondInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'imageTitle']),
        "secondImageUrl": content.getIn(['content', 'layoutFilteredContent', 'secondInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'imageUrl']),
        "secondImageNewTab": content.getIn(['content', 'layoutFilteredContent', 'secondInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'imageNewTab']),
        "secondVideoPath": content.getIn(['content', 'layoutFilteredContent', 'secondInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'videoPath']),
        "secondVideoAutoplay": content.getIn(['content', 'layoutFilteredContent', 'secondInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'videoAutoplay']),
        "secondVideoAlt": content.getIn(['content', 'layoutFilteredContent', 'secondInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'videoAlt']),
        "secondVideoTitle": content.getIn(['content', 'layoutFilteredContent', 'secondInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'videoTitle']),
        "secondVideoBg": content.getIn(['content', 'layoutFilteredContent', 'secondInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'videoBg']),
        "contentSectionBgColor": content.getIn(['content', 'layoutFilteredContent', 'secondInterstitial', 'contentSectionBgColor']),
    }
    return contentInterstitial;
}

function contentInterstitialsThirdImage(content, isDesktop) {
    const contentInterstitial = {
        "thirdTitle": content.getIn(['content', 'layoutFilteredContent', 'thirdInterstitial', 'title']),
        "thirdDescription": content.getIn(['content', 'layoutFilteredContent', 'thirdInterstitial', 'description']),
        "thirdCtaPrimaryBgColor": content.getIn(['content', 'layoutFilteredContent','thirdInterstitial', 'cta', 'ctaPrimaryBgColor']),
        "thirdCtaPrimaryNewTab": content.getIn(['content', 'layoutFilteredContent','thirdInterstitial', 'cta', 'ctaPrimaryNewTab']),
        "thirdCtaPrimaryText": content.getIn(['content', 'layoutFilteredContent','thirdInterstitial', 'cta', 'ctaPrimaryText']),
        "thirdCtaPrimaryURL": content.getIn(['content', 'layoutFilteredContent','thirdInterstitial', 'cta', 'ctaPrimaryUrl']),
        "thirdCtaPrimaryType": content.getIn(['content', 'layoutFilteredContent','thirdInterstitial', 'cta', 'ctaPrimaryType']),
        "thirdCtaPrimaryUnderlined": content.getIn(['content', 'layoutFilteredContent','thirdInterstitial', 'cta', 'ctaPrimaryUnderlined']),
        "thirdCtaTextAlignment": content.getIn(['content', 'layoutFilteredContent','thirdInterstitial', 'cta', 'ctaTextAlignment']),
        "thirdCtaSecondaryBgColor": content.getIn(['content', 'layoutFilteredContent','thirdInterstitial', 'cta', 'ctaSecondaryBgColor']),
        "thirdCtaSecondaryText": content.getIn(['content', 'layoutFilteredContent','thirdInterstitial', 'cta', 'ctaSecondaryText']),
        "thirdCtaSecondaryURL": content.getIn(['content', 'layoutFilteredContent','thirdInterstitial', 'cta', 'ctaSecondaryUrl']),
        "thirdCtaSecondaryNewTab": content.getIn(['content', 'layoutFilteredContent','thirdInterstitial', 'cta', 'ctaSecondaryNewTab']),
        "thirdCtaSecondaryType": content.getIn(['content', 'layoutFilteredContent','thirdInterstitial', 'cta', 'ctaSecondaryType']),
        "thirdCtaSecondaryUnderlined": content.getIn(['content', 'layoutFilteredContent','thirdInterstitial', 'cta', 'ctaSecondaryUnderlined']),
        "thirdImageAlt": content.getIn(['content', 'layoutFilteredContent', 'thirdInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'imageAlt']),
        "thirdImagePath": content.getIn(['content', 'layoutFilteredContent', 'thirdInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'imagePath']),
        "thirdImageTitle": content.getIn(['content', 'layoutFilteredContent', 'thirdInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'imageTitle']),
        "thirdImageUrl": content.getIn(['content', 'layoutFilteredContent', 'thirdInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'imageUrl']),
        "thirdImageNewTab": content.getIn(['content', 'layoutFilteredContent', 'thirdInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'imageNewTab']),
        "thirdVideoPath": content.getIn(['content', 'layoutFilteredContent', 'thirdInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'videoPath']),
        "thirdVideoAutoplay": content.getIn(['content', 'layoutFilteredContent', 'thirdInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'videoAutoplay']),
        "thirdVideoAlt": content.getIn(['content', 'layoutFilteredContent', 'thirdInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'videoAlt']),
        "thirdVideoTitle": content.getIn(['content', 'layoutFilteredContent', 'thirdInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'videoTitle']),
        "thirdVideoBg": content.getIn(['content', 'layoutFilteredContent', 'thirdInterstitial', `${isDesktop ? 'multimedia' : 'tabletMultimedia'}`, 'videoBg']),
        "contentSectionBgColor": content.getIn(['content', 'layoutFilteredContent', 'thirdInterstitial', 'contentSectionBgColor']),
    }
    return contentInterstitial;
}

function buildTemplateCommercialA (content, imageClickFunc, closeOptOutFunc, isDesktop, closeNotShowAgain) {
    const contentInterstitial = contentInterstitialsFirstImage(content, isDesktop);
    const titleFontSize = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','titleFontSize']);
    const titleLineHeight = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','titleLineHeight']);
    const descFontSize = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','descriptionFontSize']);
    const descLineHeight = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','descriptionLineHeight']);
    const titleString = titleFontSize > 0 && titleLineHeight > 0 ? `<span style="font-size:${titleFontSize}px;line-height:${titleLineHeight}em">${contentInterstitial.firstTitle}</span>`: contentInterstitial.firstTitle;    
    const descString = descFontSize > 0 && descLineHeight > 0 ? `<span style="font-size:${descFontSize}px;line-height:${descLineHeight}em">${contentInterstitial.firstDescription}</span>`: contentInterstitial.firstDescription; 
    return (
        <InterstitialA
            ref={closeNotShowAgain}
            handleOnClose={closeOptOutFunc}
            handleImgClick={imageClickFunc}
            title={titleString}
            description={descString}
            legalDescription={contentInterstitial.legalDescription}
            ctaTextAlignment={contentInterstitial.firstCtaTextAlignment}
            ctaPrimaryBgColor={contentInterstitial.firstCtaPrimaryBgColor}
            ctaPrimaryNewTab={contentInterstitial.firstCtaPrimaryNewTab}
            ctaPrimaryText={contentInterstitial.firstCtaPrimaryText}
            ctaPrimaryURL={contentInterstitial.firstCtaPrimaryURL}
            ctaPrimaryType={contentInterstitial.firstCtaPrimaryType}
            ctaPrimaryUnderlined={contentInterstitial.firstCtaPrimaryUnderlined}
            ctaSecondaryBgColor={contentInterstitial.firstCtaSecondaryBgColor}
            ctaSecondaryText={contentInterstitial.firstCtaSecondaryText}
            ctaSecondaryURL={contentInterstitial.firstCtaSecondaryURL}
            ctaSecondaryNewTab={contentInterstitial.firstCtaSecondaryNewTab}
            ctaSecondaryType={contentInterstitial.firstCtaSecondaryType}
            ctaSecondaryUnderlined={contentInterstitial.firstCtaSecondaryUnderlined}
            imagePath={contentInterstitial.firstImagePath}
            imageUrl={contentInterstitial.firstImageUrl}
            imageTitle={contentInterstitial.firstImageTitle}
            imageAlt={contentInterstitial.firstImageAlt}
            imageNewTab={contentInterstitial.firstImageNewTab}
            videoTitle={contentInterstitial.firstVideoTitle}
            videoAlt={contentInterstitial.firstVideoAlt}
            videoPath={contentInterstitial.firstVideoPath}
            videoAutoplay={contentInterstitial.firstVideoAutoplay}
            videoBg={contentInterstitial.firstVideoBg}
        />
    );
}

function buildTemplateCommercialB (content, imageClickFunc, closeOptOutFunc, fieldLayoutType, isDesktop, closeNotShowAgain) {
    const contentInterstitial = contentInterstitialsFirstImage(content, isDesktop);
    const titleFontSize = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','titleFontSize']);
    const titleLineHeight = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','titleLineHeight']);
    const descFontSize = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','descriptionFontSize']);
    const descLineHeight = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','descriptionLineHeight']);
    const titleString = titleFontSize > 0 && titleLineHeight > 0 ? `<span style="font-size:${titleFontSize}px;line-height:${titleLineHeight}em">${contentInterstitial.firstTitle}</span>`: contentInterstitial.firstTitle;    
    const descString = descFontSize > 0 && descLineHeight > 0 ? `<span style="font-size:${descFontSize}px;line-height:${descLineHeight}em">${contentInterstitial.firstDescription}</span>`: contentInterstitial.firstDescription;
    return(
        <InterstitialB
            ref={closeNotShowAgain}
            handleOnClose={closeOptOutFunc}
            handleImgClick={imageClickFunc}
            fieldLayoutType={fieldLayoutType}
            title={titleString}
            description={descString}
            legalDescription={contentInterstitial.legalDescription}
            ctaTextAlignment={contentInterstitial.firstCtaTextAlignment}
            ctaPrimaryBgColor={contentInterstitial.firstCtaPrimaryBgColor}
            ctaPrimaryNewTab={contentInterstitial.firstCtaPrimaryNewTab}
            ctaPrimaryText={contentInterstitial.firstCtaPrimaryText}
            ctaPrimaryURL={contentInterstitial.firstCtaPrimaryURL}
            ctaPrimaryType={contentInterstitial.firstCtaPrimaryType}
            ctaPrimaryUnderlined={contentInterstitial.firstCtaPrimaryUnderlined}
            ctaSecondaryBgColor={contentInterstitial.firstCtaSecondaryBgColor}
            ctaSecondaryText={contentInterstitial.firstCtaSecondaryText}
            ctaSecondaryURL={contentInterstitial.firstCtaSecondaryURL}
            ctaSecondaryNewTab={contentInterstitial.firstCtaSecondaryNewTab}
            ctaSecondaryType={contentInterstitial.firstCtaSecondaryType}
            ctaSecondaryUnderlined={contentInterstitial.firstCtaSecondaryUnderlined}
            imagePath={contentInterstitial.firstImagePath}
            imageUrl={contentInterstitial.firstImageUrl}
            imageTitle={contentInterstitial.firstImageTitle}
            imageAlt={contentInterstitial.firstImageAlt}
            imageNewTab={contentInterstitial.firstImageNewTab}
            videoTitle={contentInterstitial.firstVideoTitle}
            videoAlt={contentInterstitial.firstVideoAlt}
            videoPath={contentInterstitial.firstVideoPath}
            videoAutoplay={contentInterstitial.firstVideoAutoplay}
            videoBg={contentInterstitial.firstVideoBg}
            contentSectionBgColor={contentInterstitial.contentSectionBgColor}
        />
    )
}

function buildTemplateCommercialC (content, imageClickFunc, closeOptOutFunc, fieldLayoutType, isDesktop, closeNotShowAgain) {
    const contentInterstitial = contentInterstitialsFirstImage(content, isDesktop);
    const titleFontSize = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','titleFontSize']);
    const titleLineHeight = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','titleLineHeight']);
    const descFontSize = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','descriptionFontSize']);
    const descLineHeight = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','descriptionLineHeight']);
    const titleString = titleFontSize > 0 && titleLineHeight > 0 ? `<span style="font-size:${titleFontSize}px;line-height:${titleLineHeight}em">${contentInterstitial.firstTitle}</span>`: contentInterstitial.firstTitle;    
    const descString = descFontSize > 0 && descLineHeight > 0 ? `<span style="font-size:${descFontSize}px;line-height:${descLineHeight}em">${contentInterstitial.firstDescription}</span>`: contentInterstitial.firstDescription;
    return(
        <InterstitialC
            ref={closeNotShowAgain}
            handleOnClose={closeOptOutFunc}
            handleImgClick={imageClickFunc}
            fieldLayoutType={fieldLayoutType}
            title={titleString}
            description={descString}
            legalDescription={contentInterstitial.legalDescription}
            ctaTextAlignment={contentInterstitial.firstCtaTextAlignment}
            ctaPrimaryBgColor={contentInterstitial.firstCtaPrimaryBgColor}
            ctaPrimaryNewTab={contentInterstitial.firstCtaPrimaryNewTab}
            ctaPrimaryText={contentInterstitial.firstCtaPrimaryText}
            ctaPrimaryURL={contentInterstitial.firstCtaPrimaryURL}
            ctaPrimaryType={contentInterstitial.firstCtaPrimaryType}
            ctaPrimaryUnderlined={contentInterstitial.firstCtaPrimaryUnderlined}
            ctaSecondaryBgColor={contentInterstitial.firstCtaSecondaryBgColor}
            ctaSecondaryText={contentInterstitial.firstCtaSecondaryText}
            ctaSecondaryURL={contentInterstitial.firstCtaSecondaryURL}
            ctaSecondaryNewTab={contentInterstitial.firstCtaSecondaryNewTab}
            ctaSecondaryType={contentInterstitial.firstCtaSecondaryType}
            ctaSecondaryUnderlined={contentInterstitial.firstCtaSecondaryUnderlined}
            imagePath={contentInterstitial.firstImagePath}
            imageUrl={contentInterstitial.firstImageUrl}
            imageTitle={contentInterstitial.firstImageTitle}
            imageAlt={contentInterstitial.firstImageAlt}
            imageNewTab={contentInterstitial.firstImageNewTab}
            videoTitle={contentInterstitial.firstVideoTitle}
            videoAlt={contentInterstitial.firstVideoAlt}
            videoPath={contentInterstitial.firstVideoPath}
            videoAutoplay={contentInterstitial.firstVideoAutoplay}
            videoBg={contentInterstitial.firstVideoBg}
            contentSectionBgColor={contentInterstitial.contentSectionBgColor}
        />
    )
}

function buildTemplateCommercialD (content, imageClickFunc, closeOptOutFunc, fieldLayoutType, isDesktop, closeNotShowAgain) {
    const contentInterstitial = contentInterstitialsFirstImage(content, isDesktop);
    const titleFontSize = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','titleFontSize']);
    const titleLineHeight = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','titleLineHeight']);
    const descFontSize = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','descriptionFontSize']);
    const descLineHeight = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','descriptionLineHeight']);
    const titleString = titleFontSize > 0 && titleLineHeight > 0 ? `<span style="font-size:${titleFontSize}px;line-height:${titleLineHeight}em">${contentInterstitial.firstTitle}</span>`: contentInterstitial.firstTitle;    
    const descString = descFontSize > 0 && descLineHeight > 0 ? `<span style="font-size:${descFontSize}px;line-height:${descLineHeight}em">${contentInterstitial.firstDescription}</span>`: contentInterstitial.firstDescription;
    return(
        <InterstitialD
            ref={closeNotShowAgain}
            handleOnClose={closeOptOutFunc}
            handleImgClick={imageClickFunc}
            fieldLayoutType={fieldLayoutType}
            title={titleString}
            description={descString}
            legalDescription={contentInterstitial.legalDescription}
            ctaTextAlignment={contentInterstitial.firstCtaTextAlignment}
            ctaPrimaryBgColor={contentInterstitial.firstCtaPrimaryBgColor}
            ctaPrimaryNewTab={contentInterstitial.firstCtaPrimaryNewTab}
            ctaPrimaryText={contentInterstitial.firstCtaPrimaryText}
            ctaPrimaryURL={contentInterstitial.firstCtaPrimaryURL}
            ctaPrimaryType={contentInterstitial.firstCtaPrimaryType}
            ctaPrimaryUnderlined={contentInterstitial.firstCtaPrimaryUnderlined}
            ctaSecondaryBgColor={contentInterstitial.firstCtaSecondaryBgColor}
            ctaSecondaryText={contentInterstitial.firstCtaSecondaryText}
            ctaSecondaryURL={contentInterstitial.firstCtaSecondaryURL}
            ctaSecondaryNewTab={contentInterstitial.firstCtaSecondaryNewTab}
            ctaSecondaryType={contentInterstitial.firstCtaSecondaryType}
            ctaSecondaryUnderlined={contentInterstitial.firstCtaSecondaryUnderlined}
            imagePath={contentInterstitial.firstImagePath}
            imageUrl={contentInterstitial.firstImageUrl}
            imageTitle={contentInterstitial.firstImageTitle}
            imageAlt={contentInterstitial.firstImageAlt}
            imageNewTab={contentInterstitial.firstImageNewTab}
            videoTitle={contentInterstitial.firstVideoTitle}
            videoAlt={contentInterstitial.firstVideoAlt}
            videoPath={contentInterstitial.firstVideoPath}
            videoAutoplay={contentInterstitial.firstVideoAutoplay}
            videoBg={contentInterstitial.firstVideoBg}
            contentSectionBgColor={contentInterstitial.contentSectionBgColor}
        />
    )
}

function buildTemplateCommercialE (content, imageClickFunc, closeOptOutFunc, isDesktop, closeNotShowAgain) {
    const contentFirstInterstitial = contentInterstitialsFirstImage(content, isDesktop);
    const contentSecondInterstitial = contentInterstitialsSecondImage(content, isDesktop);
    const contentThirdInterstitial = contentInterstitialsThirdImage(content, isDesktop);
    const titleFontSize = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','titleFontSize']);
    const titleLineHeight = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','titleLineHeight']);
    const descFontSize = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','descriptionFontSize']);
    const descLineHeight = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','descriptionLineHeight']);
    const titleString = titleFontSize > 0 && titleLineHeight > 0 ? `<span style="font-size:${titleFontSize}px;line-height:${titleLineHeight}em">${contentFirstInterstitial.firstTitle}</span>`: contentFirstInterstitial.firstTitle;    
    const descString = descFontSize > 0 && descLineHeight > 0 ? `<span style="font-size:${descFontSize}px;line-height:${descLineHeight}em">${contentFirstInterstitial.firstDescription}</span>`: contentFirstInterstitial.firstDescription;
    return(
        <InterstitialE
            ref={closeNotShowAgain}
            handleOnClose={closeOptOutFunc}
            legalDescription={contentFirstInterstitial.legalDescription}
            headerTitle={contentSecondInterstitial.headerTitle}
            leftTitle={titleString}
            leftDescription={descString}
            leftCtaPrimaryBgColor={contentFirstInterstitial.firstCtaPrimaryBgColor}
            leftCtaPrimaryNewTab={contentFirstInterstitial.firstCtaPrimaryNewTab}
            leftCtaPrimaryText={contentFirstInterstitial.firstCtaPrimaryText}
            leftCtaPrimaryURL={contentFirstInterstitial.firstCtaPrimaryURL}
            leftCtaPrimaryType={contentFirstInterstitial.firstCtaPrimaryType}
            leftCtaPrimaryUnderlined={contentFirstInterstitial.firstCtaPrimaryUnderlined}
            leftCtaTextAlignment={contentFirstInterstitial.firstCtaTextAlignment}
            leftCtaSecondaryBgColor={contentFirstInterstitial.firstCtaSecondaryBgColor}
            leftCtaSecondaryText={contentFirstInterstitial.firstCtaSecondaryText}
            leftCtaSecondaryURL={contentFirstInterstitial.firstCtaSecondaryURL}
            leftCtaSecondaryNewTab={contentFirstInterstitial.firstCtaSecondaryNewTab}
            leftCtaSecondaryType={contentFirstInterstitial.firstCtaSecondaryType}
            leftCtaSecondaryUnderlined={contentFirstInterstitial.firstCtaSecondaryUnderlined}
            leftImageAlt={contentFirstInterstitial.firstImageAlt}
            leftImagePath={contentFirstInterstitial.firstImagePath}
            leftImageTitle={contentFirstInterstitial.firstImageTitle}
            leftImageUrl={contentFirstInterstitial.firstImageUrl}
            leftImageNewTab={contentFirstInterstitial.firstImageNewTab}
            leftHandleImgClick={imageClickFunc}
            leftVideoPath={contentFirstInterstitial.firstVideoPath}
            leftVideoAutoplay={contentFirstInterstitial.firstVideoAutoplay}
            leftVideoAlt={contentFirstInterstitial.firstVideoAlt}
            leftVideoTitle={contentFirstInterstitial.firstVideoTitle}
            leftVideoBg={contentFirstInterstitial.firstVideoBg}
            centerTitle={contentSecondInterstitial.secondTitle}
            centerDescription={contentSecondInterstitial.secondDescription}
            centerCtaPrimaryBgColor={contentSecondInterstitial.secondCtaPrimaryBgColor}
            centerCtaPrimaryNewTab={contentSecondInterstitial.secondCtaPrimaryNewTab}
            centerCtaPrimaryText={contentSecondInterstitial.secondCtaPrimaryText}
            centerCtaPrimaryURL={contentSecondInterstitial.secondCtaPrimaryURL}
            centerCtaPrimaryType={contentSecondInterstitial.secondCtaPrimaryType}
            centerCtaPrimaryUnderlined={contentSecondInterstitial.secondCtaPrimaryUnderlined}
            centerCtaTextAlignment={contentSecondInterstitial.secondCtaTextAlignment}
            centerCtaSecondaryBgColor={contentSecondInterstitial.secondCtaSecondaryBgColor}
            centerCtaSecondaryText={contentSecondInterstitial.secondCtaSecondaryText}
            centerCtaSecondaryURL={contentSecondInterstitial.secondCtaSecondaryURL}
            centerCtaSecondaryNewTab={contentSecondInterstitial.secondCtaSecondaryNewTab}
            centerCtaSecondaryType={contentSecondInterstitial.secondCtaSecondaryType}
            centerCtaSecondaryUnderlined={contentSecondInterstitial.secondCtaSecondaryUnderlined}
            centerImageAlt={contentSecondInterstitial.secondImageAlt}
            centerImagePath={contentSecondInterstitial.secondImagePath}
            centerImageTitle={contentSecondInterstitial.secondImageTitle}
            centerImageUrl={contentSecondInterstitial.secondImageUrl}
            centerImageNewTab={contentSecondInterstitial.secondImageNewTab}
            centerHandleImgClick={imageClickFunc}
            centerVideoPath={contentSecondInterstitial.secondVideoPath}
            centerVideoAutoplay={contentSecondInterstitial.secondVideoAutoplay}
            centerVideoAlt={contentSecondInterstitial.secondVideoAlt}
            centerVideoTitle={contentSecondInterstitial.secondVideoTitle}
            centerVideoBg={contentSecondInterstitial.secondVideoBg}
            rightTitle={contentThirdInterstitial.thirdTitle}
            rightDescription={contentThirdInterstitial.thirdDescription}
            rightCtaPrimaryBgColor={contentThirdInterstitial.thirdCtaPrimaryBgColor}
            rightCtaPrimaryNewTab={contentThirdInterstitial.thirdCtaPrimaryNewTab}
            rightCtaPrimaryText={contentThirdInterstitial.thirdCtaPrimaryText}
            rightCtaPrimaryURL={contentThirdInterstitial.thirdCtaPrimaryURL}
            rightCtaPrimaryType={contentThirdInterstitial.thirdCtaPrimaryType}
            rightCtaPrimaryUnderlined={contentThirdInterstitial.thirdCtaPrimaryUnderlined}
            rightCtaTextAlignment={contentThirdInterstitial.thirdCtaTextAlignment}
            rightCtaSecondaryBgColor={contentThirdInterstitial.thirdCtaSecondaryBgColor}
            rightCtaSecondaryText={contentThirdInterstitial.thirdCtaSecondaryText}
            rightCtaSecondaryURL={contentThirdInterstitial.thirdCtaSecondaryURL}
            rightCtaSecondaryNewTab={contentThirdInterstitial.thirdCtaSecondaryNewTab}
            rightCtaSecondaryType={contentThirdInterstitial.thirdCtaSecondaryType}
            rightCtaSecondaryUnderlined={contentThirdInterstitial.thirdCtaSecondaryUnderlined}
            rightImageAlt={contentThirdInterstitial.thirdImageAlt}
            rightImagePath={contentThirdInterstitial.thirdImagePath}
            rightImageTitle={contentThirdInterstitial.thirdImageTitle}
            rightImageUrl={contentThirdInterstitial.thirdImageUrl}
            rightImageNewTab={contentThirdInterstitial.thirdImageNewTab}
            rightHandleImgClick={imageClickFunc}
            rightVideoPath={contentThirdInterstitial.thirdVideoPath}
            rightVideoAutoplay={contentThirdInterstitial.thirdVideoAutoplay}
            rightVideoAlt={contentThirdInterstitial.thirdVideoAlt}
            rightVideoTitle={contentThirdInterstitial.thirdVideoTitle}
            rightVideoBg={contentThirdInterstitial.thirdVideoBg}
        />
    )
}

function buildTemplateCommercialF (content, imageClickFunc, closeOptOutFunc, isDesktop, closeNotShowAgain) {
    const contentFirstInterstitial = contentInterstitialsFirstImage(content, isDesktop);
    const contentSecondInterstitial = contentInterstitialsSecondImage(content, isDesktop);
    const titleFontSize = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','titleFontSize']);
    const titleLineHeight = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','titleLineHeight']);
    const descFontSize = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','descriptionFontSize']);
    const descLineHeight = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','descriptionLineHeight']);
    const titleString = titleFontSize > 0 && titleLineHeight > 0 ? `<span style="font-size:${titleFontSize}px;line-height:${titleLineHeight}em">${contentFirstInterstitial.firstTitle}</span>`: contentFirstInterstitial.firstTitle;    
    const descString = descFontSize > 0 && descLineHeight > 0 ? `<span style="font-size:${descFontSize}px;line-height:${descLineHeight}em">${contentFirstInterstitial.firstDescription}</span>`: contentFirstInterstitial.firstDescription;
    return(
        <InterstitialF
            ref={closeNotShowAgain}
            handleOnClose={closeOptOutFunc}
            legalDescription={contentFirstInterstitial.legalDescription}
            leftTitle={titleString}
            leftDescription={descString}
            headerTitle={contentSecondInterstitial.headerTitle}
            leftCtaPrimaryBgColor={contentFirstInterstitial.firstCtaPrimaryBgColor}
            leftCtaPrimaryNewTab={contentFirstInterstitial.firstCtaPrimaryNewTab}
            leftCtaPrimaryText={contentFirstInterstitial.firstCtaPrimaryText}
            leftCtaPrimaryURL={contentFirstInterstitial.firstCtaPrimaryURL}
            leftCtaPrimaryType={contentFirstInterstitial.firstCtaPrimaryType}
            leftCtaPrimaryUnderlined={contentFirstInterstitial.firstCtaPrimaryUnderlined}
            leftCtaTextAlignment={contentFirstInterstitial.firstCtaTextAlignment}
            leftCtaSecondaryBgColor={contentFirstInterstitial.firstCtaSecondaryBgColor}
            leftCtaSecondaryText={contentFirstInterstitial.firstCtaSecondaryText}
            leftCtaSecondaryURL={contentFirstInterstitial.firstCtaSecondaryURL}
            leftCtaSecondaryNewTab={contentFirstInterstitial.firstCtaSecondaryNewTab}
            leftCtaSecondaryType={contentFirstInterstitial.firstCtaSecondaryType}
            leftCtaSecondaryUnderlined={contentFirstInterstitial.firstCtaSecondaryUnderlined}
            leftImageAlt={contentFirstInterstitial.firstImageAlt}
            leftImagePath={contentFirstInterstitial.firstImagePath}
            leftImageTitle={contentFirstInterstitial.firstImageTitle}
            leftImageUrl={contentFirstInterstitial.firstImageUrl}
            leftImageNewTab={contentFirstInterstitial.firstImageNewTab}
            leftHandleImgClick={imageClickFunc}
            leftVideoPath={contentFirstInterstitial.firstVideoPath}
            leftVideoAutoplay={contentFirstInterstitial.firstVideoAutoplay}
            leftVideoAlt={contentFirstInterstitial.firstVideoAlt}
            leftVideoTitle={contentFirstInterstitial.firstVideoTitle}
            leftVideoBg={contentFirstInterstitial.firstVideoBg}
            videoBg={contentFirstInterstitial.firstVideoBg}
            rightTitle={contentSecondInterstitial.secondTitle}
            rightDescription={contentSecondInterstitial.secondDescription}
            rightCtaPrimaryBgColor={contentSecondInterstitial.secondCtaPrimaryBgColor}
            rightCtaPrimaryNewTab={contentSecondInterstitial.secondCtaPrimaryNewTab}
            rightCtaPrimaryText={contentSecondInterstitial.secondCtaPrimaryText}
            rightCtaPrimaryURL={contentSecondInterstitial.secondCtaPrimaryURL}
            rightCtaPrimaryType={contentSecondInterstitial.secondCtaPrimaryType}
            rightCtaPrimaryUnderlined={contentSecondInterstitial.secondCtaPrimaryUnderlined}
            rightCtaTextAlignment={contentSecondInterstitial.secondCtaTextAlignment}
            rightCtaSecondaryBgColor={contentSecondInterstitial.secondCtaSecondaryBgColor}
            rightCtaSecondaryText={contentSecondInterstitial.secondCtaSecondaryText}
            rightCtaSecondaryURL={contentSecondInterstitial.secondCtaSecondaryURL}
            rightCtaSecondaryNewTab={contentSecondInterstitial.secondCtaSecondaryNewTab}
            rightCtaSecondaryType={contentSecondInterstitial.secondCtaSecondaryType}
            rightCtaSecondaryUnderlined={contentSecondInterstitial.secondCtaSecondaryUnderlined}
            rightImageAlt={contentSecondInterstitial.secondImageAlt}
            rightImagePath={contentSecondInterstitial.secondImagePath}
            rightImageTitle={contentSecondInterstitial.secondImageTitle}
            rightImageUrl={contentSecondInterstitial.secondImageUrl}
            rightImageNewTab={contentSecondInterstitial.secondImageNewTab}
            rightHandleImgClick={imageClickFunc}
            rightVideoPath={contentSecondInterstitial.secondVideoPath}
            rightVideoAutoplay={contentSecondInterstitial.secondVideoAutoplay}
            rightVideoAlt={contentSecondInterstitial.secondVideoAlt}
            rightVideoTitle={contentSecondInterstitial.secondVideoTitle}
            rightVideoBg={contentSecondInterstitial.secondVideoBg}
        />
    )
}

function buildFlexibleTextForCommercialBox(contentInterstitial) {
    let flexibleText = {};
    flexibleText['fieldFlexible'] = !parseInt(contentInterstitial.fieldFlexible);
    flexibleText['fieldBoxDescription'] = contentInterstitial.flexibleText.getIn([0, 'value', 'fieldBody', 'processed']);
    flexibleText['fieldIconAndTextItems'] = contentInterstitial.flexibleText.map(text => {
        return {
            assetType: text.get('assetType'),
            font_icon: text.get('icon'),
            imageAlt: '',
            imagePath: '',
            value: text.getIn(['value', 'fieldBody', 'processed'])
        }
    })
    return flexibleText;
}


function buildTemplateCommercialG(content, closeOptOutFunc, isDesktop, closeNotShowAgain) {
    const contentInterstitial = contentInterstitialsFirstImage(content, isDesktop);
    const flexibleText = buildFlexibleTextForCommercialBox(contentInterstitial);
    const titleFontSize = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','titleFontSize']);
    const titleLineHeight = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','titleLineHeight']);
    const descFontSize = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','descriptionFontSize']);
    const descLineHeight = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','descriptionLineHeight']);
    const titleString = titleFontSize > 0 && titleLineHeight > 0 ? `<span style="font-size:${titleFontSize}px;line-height:${titleLineHeight}em">${contentInterstitial.firstTitle}</span>`: contentInterstitial.firstTitle;    
    const descString = descFontSize > 0 && descLineHeight > 0 ? `<span style="font-size:${descFontSize}px;line-height:${descLineHeight}em">${contentInterstitial.firstDescription}</span>`: contentInterstitial.firstDescription;
    return (
        <InterstitialG
            ref={closeNotShowAgain}
            title={titleString}
            handleOnClose={closeOptOutFunc}
            legalDescription={descString}
            ctaTextAlignment={contentInterstitial.firstCtaTextAlignment}
            ctaPrimaryBgColor={contentInterstitial.firstCtaPrimaryBgColor}
            ctaPrimaryNewTab={contentInterstitial.firstCtaPrimaryNewTab}
            ctaPrimaryText={contentInterstitial.firstCtaPrimaryText}
            ctaPrimaryUrl={contentInterstitial.firstCtaPrimaryURL}
            ctaPrimaryType={contentInterstitial.firstCtaPrimaryType}
            ctaPrimaryRel={contentInterstitial.firstCtaPrimaryRel}
            ctaPrimaryUnderlined={contentInterstitial.firstCtaPrimaryUnderlined}
            extraLegalDescription={contentInterstitial.extraLegalDescription}
            flexibleText={flexibleText}
            imagePath={contentInterstitial.firstImagePath}
            imageTitle={contentInterstitial.firstImageTitle}
            imageAlt={contentInterstitial.firstImageAlt}
            validDate={contentInterstitial.validDate}
            contentSectionTheme={contentInterstitial.boxAlignment}
            contentSectionOrientation={contentInterstitial.contrast}
        />
    )
}

function buildTemplateCommercialAdvance(content, immProfile, immProfileShippingAddress, imageClickFunc, closeOptOutFunc, fieldLayoutType, isDesktop, closeNotShowAgain, history) {
    
    const contentInterstitial = advanceInterstitialContents(content, immProfile, immProfileShippingAddress, isDesktop);
    const {
        contentSectionBgColor,
        fieldsPlaceHolder,
        fieldsPlaceHolderColor,
        firstCtaPrimaryBgColor,
        firstCtaPrimaryNewTab,
        firstCtaPrimaryText,
        firstCtaPrimaryType,
        firstCtaPrimaryURL,
        firstCtaPrimaryUnderlined,
        firstCtaSecondaryBgColor,
        firstCtaSecondaryNewTab,
        firstCtaSecondaryText,
        firstCtaSecondaryType,
        firstCtaSecondaryURL,
        firstCtaSecondaryUnderlined,
        firstCtaTextAlignment,
        firstDescription,
        firstImageAlt,
        firstImageNewTab,
        firstImagePath,
        firstImageTitle,
        firstImageUrl,
        firstTitle,
        firstVideoAlt,
        firstVideoAutoplay,
        firstVideoBg,
        firstVideoPath,
        firstVideoTitle,
        legalDescription,
        missingFieldBgColor,
        missingFieldLabel,
    } = contentInterstitial;
    const titleFontSize = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','titleFontSize']);
    const titleLineHeight = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','titleLineHeight']);
    const descFontSize = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','descriptionFontSize']);
    const descLineHeight = content.getIn(['content', 'layoutFilteredContent','firstInterstitial','descriptionLineHeight']);
    const titleString = titleFontSize > 0 && titleLineHeight > 0 ? `<span style="font-size:${titleFontSize}px;line-height:${titleLineHeight}em">${firstTitle}</span>`: firstTitle;    
    const descString = descFontSize > 0 && descLineHeight > 0 ? `<span style="font-size:${descFontSize}px;line-height:${descLineHeight}em">${firstDescription}</span>`: firstDescription;
    const webURL = window.location.host
    let redirectionWebURL = ''
    
    if(firstCtaPrimaryURL.includes(webURL)){
        const splitURL = firstCtaPrimaryURL.split(webURL)
        redirectionWebURL = splitURL.length >= 2 ? firstCtaPrimaryURL.split(webURL)[splitURL.length - 1] : ''
    }
    return redirectionWebURL === '' ? (
        <InterstitialAdvanced
            contentSectionBgColor={contentSectionBgColor}
            ctaPrimaryBgColor={firstCtaPrimaryBgColor}
            ctaPrimaryNewTab={firstCtaPrimaryNewTab}
            ctaPrimaryText={firstCtaPrimaryText}
            ctaPrimaryType={firstCtaPrimaryType}
            ctaPrimaryURL={firstCtaPrimaryURL}
            ctaPrimaryUnderlined={firstCtaPrimaryUnderlined}
            ctaSecondaryBgColor={firstCtaSecondaryBgColor}
            ctaSecondaryNewTab={firstCtaSecondaryNewTab}
            ctaSecondaryText={firstCtaSecondaryText}
            ctaSecondaryType={firstCtaSecondaryType}
            ctaSecondaryURL={firstCtaSecondaryURL}
            ctaSecondaryUnderlined={firstCtaSecondaryUnderlined}
            ctaTextAlignment={firstCtaTextAlignment}
            description={descString}
            fieldLayoutType={fieldLayoutType}
            fieldsPlaceHolder={fieldsPlaceHolder}
            fieldsPlaceHolderColor={fieldsPlaceHolderColor}
            handleImgClick={imageClickFunc}
            handleOnClose={closeOptOutFunc}
            imageAlt={firstImageAlt}
            imageNewTab={firstImageNewTab}
            imagePath={firstImagePath}
            imageTitle={firstImageTitle}
            imageUrl={firstImageUrl}
            legalDescription={legalDescription}
            missingFieldBgColor={missingFieldBgColor}
            missingFieldLabel={missingFieldLabel}
            ref={closeNotShowAgain}
            title={titleString}
            videoAlt={firstVideoAlt}
            videoAutoplay={firstVideoAutoplay}
            videoBg={firstVideoBg}
            videoPath={firstVideoPath}
            videoTitle={firstVideoTitle}
        />
    )
    :
    (<InterstitialAdvanced
            ctaPrimaryOnClick={()=>{
                history.push(redirectionWebURL);
                closeOptOutFunc()
            }}
            contentSectionBgColor={contentSectionBgColor}
            ctaPrimaryBgColor={firstCtaPrimaryBgColor}
            ctaPrimaryNewTab={firstCtaPrimaryNewTab}
            ctaPrimaryText={firstCtaPrimaryText}
            ctaPrimaryType={firstCtaPrimaryType}
            ctaPrimaryURL={firstCtaPrimaryURL}
            ctaPrimaryUnderlined={firstCtaPrimaryUnderlined}
            ctaSecondaryBgColor={firstCtaSecondaryBgColor}
            ctaSecondaryNewTab={firstCtaSecondaryNewTab}
            ctaSecondaryText={firstCtaSecondaryText}
            ctaSecondaryType={firstCtaSecondaryType}
            ctaSecondaryURL={firstCtaSecondaryURL}
            ctaSecondaryUnderlined={firstCtaSecondaryUnderlined}
            ctaTextAlignment={firstCtaTextAlignment}
            description={descString}
            fieldLayoutType={fieldLayoutType}
            fieldsPlaceHolder={fieldsPlaceHolder}
            fieldsPlaceHolderColor={fieldsPlaceHolderColor}
            handleImgClick={imageClickFunc}
            handleOnClose={closeOptOutFunc}
            imageAlt={firstImageAlt}
            imageNewTab={firstImageNewTab}
            imagePath={firstImagePath}
            imageTitle={firstImageTitle}
            imageUrl={firstImageUrl}
            legalDescription={legalDescription}
            missingFieldBgColor={missingFieldBgColor}
            missingFieldLabel={missingFieldLabel}
            ref={closeNotShowAgain}
            title={titleString}
            videoAlt={firstVideoAlt}
            videoAutoplay={firstVideoAutoplay}
            videoBg={firstVideoBg}
            videoPath={firstVideoPath}
            videoTitle={firstVideoTitle}
        />)
}

// Token functions (remember that the user close or not the interstitial)
function updateTokenUserInterstitial(content) {
    const immInterstitialsType = content.get('type');
    const nidUser = getPersonTypeAndCodeHashed();
    const nidInterstitial = immInterstitialsType === 'fioc' ? content.getIn(['content', 'codMensaje']).toString() : content.getIn(['content', 'id']).toString();
    const delayToShow = moment.duration(parseInt(content.getIn(['content', 'delay'])), 'milliseconds').asDays(); //convert milliseconds to days

    if (parseInt(content.getIn(['content', 'delay']) !== 0)) {
        switch (immInterstitialsType) {
            case 'cms':
                Storage.cookies.set(`immL-${nidUser}-${nidInterstitial}`, true, { expires: delayToShow });
                break;
            case 'fioc':
                Storage.cookies.set(`immF-${nidUser}`, true, { expires: delayToShow });
                break;
            case 'commercial':
                Storage.cookies.set(`immC-${nidUser}-${nidInterstitial}`, true, { expires: delayToShow });
                break;
            default:
                break;
        }
    }
}

function hasTokenInterstitial(content) {
    const immInterstitialsType = content.get('type');
    const nidUser = getPersonTypeAndCodeHashed();
    const sizeContent = content.size;
    let hasToken = false
    if (sizeContent > 0 && immInterstitialsType !== undefined) {
        const nidInterstitial = content.getIn(['content', 'codMensaje']) ? content.getIn(['content', 'codMensaje']).toString() : content.getIn(['content', 'id']).toString();

        switch (immInterstitialsType) {
            case 'cms':
                hasToken = Storage.cookies.get(`immL-${nidUser}-${nidInterstitial}`) === true;
                break;
            case 'fioc':
                hasToken = Storage.cookies.get(`immF-${nidUser}`) === true;
                break;
            case 'commercial':
                hasToken = Storage.cookies.get(`immC-${nidUser}-${nidInterstitial}`) === true;
                break
            case 'gdpr':
                hasToken = Storage.cookies.get(`immC-${nidUser}-${nidInterstitial}`) === true;
                break
            default:
                break;
        }
    }

    return hasToken;
}

function generateTokenSessionInterstitial() {
    Storage.localStorage.set('immG', Storage.cookies.get('tokenCredential'));
}

function compareTokenSessionInterstitial() {
    if (Storage.localStorage.get('immG')) {
        return(Storage.localStorage.get('immG') === Storage.cookies.get('tokenCredential'));
    } else {
        return false
    }

}

module.exports = {
    buildTemplateCommercialA,
    buildTemplateCommercialB,
    buildTemplateCommercialC,
    buildTemplateCommercialD,
    buildTemplateCommercialE,
    buildTemplateCommercialF,
    buildTemplateCommercialG,
    buildTemplateCommercialAdvance,
    updateTokenUserInterstitial,
    hasTokenInterstitial,
    generateTokenSessionInterstitial,
    compareTokenSessionInterstitial,
};
